(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(65970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ SubscriptionModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47727);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(473);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87357);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18633);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _contexts_AuthenticationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43477);










var ModalContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "e16465q70"
})(function() {
    return {
        background: "linear-gradient(0deg, #000000 0%, #191040b5 30%, rgba(0,212,255,0) 100%)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        cursor: "default",
        button: {
            transition: "0.01s",
            "&:hover": {
                background: "#3352fe",
                outline: "1px solid white"
            }
        }
    };
});
var HeaderContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q71"
})(function() {
    return {
        fontSize: "54px",
        fontWeight: "600",
        textTransform: "uppercase",
        p: {
            color: "white"
        },
        "@media screen and (max-width: 800px)": {
            fontSize: "24px"
        }
    };
});
var HeaderSubText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q72"
})(function() {
    return {
        color: "orange",
        marginBottom: "16px"
    };
});
var LoginButtonContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q73"
})(function() {
    return {
        position: "absolute",
        right: "16px",
        top: "16px",
        display: "block",
        "@media screen and (max-width: 800px)": {
            display: "none"
        }
    };
});
var PrimaryButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e16465q74"
})(function() {
    return {
        background: "#3352fe",
        padding: "8px 24px",
        color: "white",
        fontSize: "18px"
    };
});
var StartButtonContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e16465q75"
})(function() {
    return {
        background: "#3352fe",
        padding: "12px 32px",
        color: "white",
        fontSize: "18px",
        "@media screen and (max-width: 800px)": {
            maxWidth: "calc(100% - 24px)"
        }
    };
});
var BoxContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "e16465q76"
})(function() {
    return {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        paddingBottom: 3,
        width: "80vw",
        height: "80vh",
        outline: "none",
        paddingTop: 2,
        background: 'url("/images/settings-bg.png")',
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        borderBottom: "2px solid #3352fe",
        "@media screen and (max-width: 800px)": {
            backgroundSize: "auto 100%"
        }
    };
});
var ListContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q77"
})(function() {
    return {};
});
var ListItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e16465q78"
})(function() {
    return {
        display: "flex",
        alignItems: "center",
        margin: "8px 0",
        color: "white",
        svg: {
            marginRight: "8px",
            height: "32px",
            width: "32px"
        }
    };
});
var TextUnderline = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e16465q79"
})(function() {
    return {
        cursor: "pointer",
        color: "white",
        textDecoration: "underline",
        "&:hover": {
            color: "#fafafa",
            textDecorationThickness: "2px"
        }
    };
});
var SubscriptionModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(true), 2), openState = ref[0], setOpenState = ref[1];
    var userToken = (0,_contexts_AuthenticationContext__WEBPACK_IMPORTED_MODULE_3__/* .useAuthenticationContext */ .l)().userToken;
    var handleClose = function() {
        setOpenState(false);
    };
    var router = (0,next_translate_routes__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var redirectAzcConnect = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                router.push("/subscription/auth");
                return [
                    2
                ];
            });
        });
        return function redirectAzcConnect() {
            return _ref.apply(this, arguments);
        };
    }();
    return openState ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ModalContainer, {
        open: !userToken && openState,
        onClose: handleClose,
        "aria-labelledby": "modal-modal-title",
        "aria-describedby": "modal-modal-description",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(BoxContainer, {
            sx: {
                bgcolor: "background.paper",
                boxShadow: 24,
                px: 4
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(LoginButtonContainer, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(PrimaryButton, {
                        color: "primary",
                        onClick: redirectAzcConnect,
                        children: "Login"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(HeaderContainer, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("p", {
                            style: {
                                marginTop: "24px",
                                marginBottom: 0
                            },
                            children: " Play all of huz."
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("p", {
                            style: {
                                margin: "8px 0"
                            },
                            children: "Try us, cancel at anytime "
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("div", {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(HeaderSubText, {
                        children: "Enjoy and play unlimited online games for only $4.99/month"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ListContainer, {
                    children: [
                        "No Advirtesement",
                        "Unlimited gameplays",
                        "Cancel at anytime",
                        "Play on any device",
                        "Children Account", 
                    ].map(function(i) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(ListItem, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    style: {
                                        color: "green"
                                    }
                                }),
                                i
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                    style: {
                        position: "absolute",
                        bottom: "32px"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                            style: {
                                marginBottom: "12px",
                                color: "white"
                            },
                            children: [
                                "HUZ is a subscription service. To see Terms and Conditions",
                                " ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TextUnderline, {
                                    href: "https://static.gamedistribution.com/terms/both.html",
                                    children: "click here."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(StartButtonContainer, {
                            color: "primary",
                            onClick: redirectAzcConnect,
                            children: "Start Your Game Adventure"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("div", {
                            style: {
                                marginTop: "12px",
                                color: "white"
                            },
                            children: [
                                "You can cancel anytime, ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TextUnderline, {
                                    onClick: handleClose,
                                    children: "or try later"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .Fragment */ .HY, {});
};


/***/ }),

/***/ 65970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ IndexPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/containers/CollectionsD/index.ts + 4 modules
var CollectionsD = __webpack_require__(42734);
;// CONCATENATED MODULE: ./src/generated/index/index.tsx




function View(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsD/* CollectionsD */._, (0,_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./src/layouts/BaseLayout/index.tsx + 12 modules
var BaseLayout = __webpack_require__(97691);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./src/utils/localize-helpers.ts
var localize_helpers = __webpack_require__(98751);
// EXTERNAL MODULE: ./src/components/AdvertisementSlot/index.ts + 2 modules
var AdvertisementSlot = __webpack_require__(29918);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/components/SubscriptionModal/index.tsx
var SubscriptionModal = __webpack_require__(96410);
// EXTERNAL MODULE: ./src/types/static.tsx
var types_static = __webpack_require__(17637);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./src/pages/index.tsx









// Koşullu import için adsRequest burada kaldırıldı











var AdvertisementSlotBottom = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot.AdvertisementSlot, {
    target: "e1lcxqjd0"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        boxShadow: theme.shadows[0],
        marginTop: theme.spacing(4),
        position: "sticky",
        bottom: "0",
        margin: "auto",
        background: "white",
        width: "728px",
        height: "90px",
        zIndex: "1"
    }, theme.breakpoints.down("lg"), {
        width: "364px",
        height: "45px"
    });
});
var Script = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("script", {
    target: "e1lcxqjd1"
})();
var __N_SSG = true;
function IndexPage(props) {
    var ref;
    var collections = props.collections, pageContext = props.pageContext;
    var ref1 = (0,esm/* useTranslation */.$G)([
        "common",
        "index"
    ]), t = ref1.t, i18n = ref1.i18n;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var _ref = appContext.useConfig(), name = _ref.name, assetAbsoluteUrl = _ref.assetAbsoluteUrl, url = _ref.url, componentOptions = _ref.componentOptions, project = _ref.project, noFollow = _ref.noFollow, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "name",
        "assetAbsoluteUrl",
        "url",
        "componentOptions",
        "project",
        "noFollow"
    ]);
    var router = (0,next_router.useRouter)();
    var paths = (0,localize_helpers/* getLocalizedPaths */.mT)(router);
    var slugs = (0,localize_helpers/* getLocalizedSlugs */.fD)(router);
    var pageContextWithPaths = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContext), {
        paths: paths,
        slugs: slugs,
        slug: (0,localize_helpers/* cleanSlug */.Hm)(router.pathname)
    });
    var siteUrl = "".concat(url === null || url === void 0 ? void 0 : url.replace(/\/+$/, ""));
    var stickyAdvertisement = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_advertisement_show;
    var header_lift = project.features.ads.header_lift;
    react.useEffect(function() {
        if (header_lift) {
            var loadAdsRequest = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var adsRequest;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    __webpack_require__.e(/* import() */ 8505).then(__webpack_require__.bind(__webpack_require__, 18505))
                                ];
                            case 1:
                                adsRequest = _state.sent().adsRequest;
                                adsRequest([
                                    "idhb-bottom-90"
                                ]);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function loadAdsRequest() {
                    return _ref.apply(this, arguments);
                };
            }();
            loadAdsRequest();
        }
    }, [
        header_lift
    ]);
    react.useEffect(function() {
        if (!header_lift) return;
        var events = router.events;
        var handleRouteChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var adsRequest;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __webpack_require__.e(/* import() */ 8505).then(__webpack_require__.bind(__webpack_require__, 18505))
                            ];
                        case 1:
                            adsRequest = _state.sent().adsRequest;
                            adsRequest([
                                "idhb-bottom-90"
                            ]);
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleRouteChange() {
                return _ref.apply(this, arguments);
            };
        }();
        events.on("routeChangeComplete", handleRouteChange);
        events.on("hashChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
            events.off("hashChangeComplete", handleRouteChange);
        };
    }, [
        router,
        header_lift
    ]);
    var seoTitle = i18n.exists("index:title", {
        fallbackLng: pageContextWithPaths.locale
    }) ? t("index:title") : t("common:title");
    var seoDescription = i18n.exists("index:description", {
        fallbackLng: pageContextWithPaths.locale
    }) ? t("index:description") : t("common:description");
    // Customized SEO
    var seo = appContext.useSeo().seo;
    // Homepage page
    if (seo === null || seo === void 0 ? void 0 : seo.pages) {
        var ref2;
        var currentPageSEO = (ref2 = seo.pages) === null || ref2 === void 0 ? void 0 : ref2.home;
        if (currentPageSEO && router.locale) {
            var seoCurrentLanguage = currentPageSEO === null || currentPageSEO === void 0 ? void 0 : currentPageSEO[router.locale];
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.title) {
                seoTitle = seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.title;
            }
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.description) {
                seoDescription = seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.description;
            }
        }
    }
    var showSubscriptionModal = componentOptions.component_project_subscription_mode;
    var ssrSeo;
    if ((props === null || props === void 0 ? void 0 : props.seo) && props.seo[0]) {
        var ref3;
        var seoObject = props.seo[0];
        if (((ref3 = seoObject.pages) === null || ref3 === void 0 ? void 0 : ref3.home) && router.locale) {
            var seoCurrentLanguage1 = seoObject.pages.home[router.locale];
            if (seoCurrentLanguage1.json_ld) {
                ssrSeo = seoCurrentLanguage1.json_ld;
            }
        }
    }
    var languageAlternatives = (0,localize_helpers/* getLocalizedPaths */.mT)(router).map(function(path) {
        return {
            hrefLang: path.locale,
            href: (ssrSeo === null || ssrSeo === void 0 ? void 0 : ssrSeo.url) ? "".concat(ssrSeo.url).concat((0,localize_helpers/* getLocalizedPaths */.mT)(router)[0].path) : "".concat(url).concat(path.path)
        };
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            showSubscriptionModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscriptionModal/* SubscriptionModal */.u, {}),
            (componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_facebook_og_image_url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                nofollow: noFollow ? true : false,
                noindex: noFollow ? true : false,
                title: seoTitle,
                description: seoDescription,
                languageAlternates: languageAlternatives.map(function(locale) {
                    return {
                        hrefLang: locale.hrefLang,
                        href: locale.href
                    };
                }),
                openGraph: {
                    images: [
                        {
                            url: "".concat(componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_facebook_og_image_url),
                            width: 512,
                            height: 512,
                            alt: "".concat(seoTitle)
                        }, 
                    ],
                    url: componentOptions.component_facebook_og_url ? componentOptions.component_facebook_og_url : url,
                    type: "website"
                }
            }),
            collections.length > 0 && ((ref = collections[0]) === null || ref === void 0 ? void 0 : ref.games.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    !componentOptions.component_breadcrumb_json_ld_is_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                        itemListElements: pageContextWithPaths.breadcrumbs.map(function(crumb, index) {
                            return {
                                position: index + 1,
                                name: crumb.name,
                                item: crumb.href
                            };
                        })
                    }),
                    ssrSeo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Script, {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify((0,_object_spread/* default */.Z)({
                                "@type": ssrSeo["@type"],
                                "@context": ssrSeo["@context"]
                            }, Object.keys(ssrSeo).reduce(function(acc, key) {
                                if (key !== "@context" && key !== "@type") {
                                    acc[key] = ssrSeo[key];
                                }
                                return acc;
                            }, {})))
                        }
                    }),
                    !componentOptions.component_collection_json_ld_is_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* CollectionPageJsonLd */.yr, {
                        name: t("common:title"),
                        hasPart: collections.map(function(collection) {
                            return {
                                about: collection.description,
                                author: {
                                    name: name
                                },
                                name: collection.name,
                                audience: "Internet",
                                keywords: "schema",
                                thumbnailUrl: "".concat(assetAbsoluteUrl).concat(collection.images.cover1x1 || collection.images.cover, "/?ar[r]=1x1&ar[w]=512&fmt=.png"),
                                image: "".concat(assetAbsoluteUrl).concat(collection.images.cover1x1 || collection.images.cover, "/")
                            };
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                pageContext: pageContextWithPaths
            })),
            stickyAdvertisement && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* BrowserView */.I3, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotBottom, {
                            configuration: types_static/* HOME_MIDDLE_ADS_CONFIGURATION */.$m,
                            elevation: 1,
                            slotIdentifier: componentOptions.component_home_middle_id || componentOptions.component_game_ads_id || "idhb-bottom-90",
                            variant: "728x90"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* MobileView */.$, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotBottom, {
                            configuration: types_static/* HOME_MIDDLE_ADS_CONFIGURATION */.$m,
                            elevation: 1,
                            slotIdentifier: componentOptions.component_home_mobile_middle_id || componentOptions.component_game_ads_id || "idhb-bottom-90",
                            variant: "320x100"
                        })
                    })
                ]
            })
        ]
    });
}
// Adding getLayout property. Allowing us to return a React component for the layout.
// This allows us to define the layout on a per-page basis. Since we're returning a function,
// we can have complex nested layouts if desired.
IndexPage.getLayout = function getLayout(page) {
    var props = page.props;
    var pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseLayout/* BaseLayout */.I, {
        pageType: "index",
        pageContext: pageContext,
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8010,2607,5730,4638,8786,7637,3236,2734,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);